<template>
  <div class="profile" v-click-outside="handleClose">
    <Loading :loading="USER_INFO_LOADING" :minimized="minimized">
      <template #default>
        <div
          class="profile__content"
          :class="{ profile__minimized: minimized }"
          @mousedown="setShow(!isShow)"
        >
          <ImageBox
            :downloadCode="userData.downloadCode"
            :defaultImage="defaultImage"
            imageClass="profile__image"
            wrapperClass="flex-center"
            loadingClass="left-4 width-24 height-24 rounded-circle"
          />
          <span v-show="!minimized" class="profile__name text-ellipsis">
            {{ userData.fullName }}
          </span>
        </div>
      </template>
    </Loading>
    <ProfileBoxPopup
      :show="isShow"
      :userData="userData"
      primaryKey="personCode"
      deskTopPopupClass="top-15"
      profileModalClass="bottom-0"
      :hasVersion="hasVersion"
      @setShow="setShow"
    />
  </div>
</template>

<script>
import Loading from "./Loading.vue";
import ProfileBoxPopup from "./ProfileBoxPopup.vue";
import ImageBox from "../image-box/ImageBox.vue";
import { pathOr } from "ramda";
import {
  generateConfig,
  generateStoreGetters,
  renderAvatar,
} from "@/shared/utils";
import { computed, ref } from "vue";

export default {
  inject: ["USER_INFO_LOADING"],
  components: {
    Loading,
    ProfileBoxPopup,
    ImageBox,
  },
  props: {
    minimized: {
      type: Boolean,
      default: false,
    },
    hasVersion: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const defaultImage = generateConfig([
      "images",
      "shared",
      "redesign",
      "empty",
      "noUser",
    ]);

    const currentUserInfo = computed(() => generateStoreGetters(["userInfo"]));
    const userData = computed(() => {
      const personCode = pathOr(
        null,
        ["person", "code"],
        currentUserInfo.value
      );
      const code = pathOr(null, ["code"], currentUserInfo.value);
      const name = pathOr("", ["person", "name"], currentUserInfo.value);
      const family = pathOr("", ["person", "family"], currentUserInfo.value);
      const mobile = pathOr("", ["mobile"], currentUserInfo.value);
      const downloadCode = pathOr(
        null,
        ["person", "download_code"],
        currentUserInfo.value
      );
      return {
        personCode,
        code,
        avatar: renderAvatar(currentUserInfo.value),
        fullName: `${name} ${family}`,
        mobile,
        downloadCode,
      };
    });

    const isShow = ref(false);
    const setShow = (val) => (isShow.value = val);
    const handleClose = () => setShow(false);

    // return data to be used in template
    return { defaultImage, userData, isShow, setShow, handleClose };
  },
};
</script>
